// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2FoR8","left":"InfoRow_left__xBv3P"};